/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/073-location2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a5 5 0 00-5 5c0 5 5 11 5 11s5-6 5-11a5 5 0 00-5-5zm0 8.063a3.063 3.063 0 110-6.126 3.063 3.063 0 010 6.126zM6.063 5a1.938 1.938 0 113.876 0 1.938 1.938 0 01-3.876 0z"/>'
  }
})
